import { DoubleLeftOutlined, DoubleRightOutlined } from "@ant-design/icons";
import { SvgButton } from "src/components/SvgButton";
import { ExploreContext } from "./useExploreContext";

export const FullscreenButton = ({ context }: { context: ExploreContext }) => {
  return (
    <SvgButton
      onClick={() => context.tabs.setFullscreen((v) => !v)}
      key={`${context.tabs.fullscreen}`}
      baseStyle={{ backgroundColor: "inherit" }}
    >
      {context.tabs.fullscreen ? (
        <DoubleLeftOutlined />
      ) : (
        <DoubleRightOutlined />
      )}
    </SvgButton>
  );
};
